import { useTheme } from "@mui/material";

const AnimatedChatLoadingComponent = () => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={24}
      viewBox="4 10 16 4"
    >
      <circle cx={16} cy={12} r={0} fill={theme.palette.text.primary}>
        <animate
          attributeName={"r"}
          begin={0.67}
          calcMode={"spline"}
          dur={"1.5s"}
          keySplines={"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"}
          repeatCount={"indefinite"}
          values={"0;1;0;0"}
        ></animate>
      </circle>
      <circle cx={12} cy={12} r={0} fill={theme.palette.text.primary}>
        <animate
          attributeName={"r"}
          begin={0.33}
          calcMode={"spline"}
          dur={"1.5s"}
          keySplines={"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"}
          repeatCount={"indefinite"}
          values={"0;1;0;0"}
        ></animate>
      </circle>
      <circle cx={8} cy={12} r={0} fill={theme.palette.text.primary}>
        <animate
          attributeName={"r"}
          begin={0}
          calcMode={"spline"}
          dur={"1.5s"}
          keySplines={"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"}
          repeatCount={"indefinite"}
          values={"0;1;0;0"}
        ></animate>
      </circle>
    </svg>
  );
};

export default AnimatedChatLoadingComponent;
